<template>
  <v-ons-modal
    :visible="isShow"
    class="loading"
  >
    <v-ons-progress-circular
      style="width:10vh; height:10vh"
      indeterminate
    />
    <div v-html="message"></div>
  </v-ons-modal>
</template>

<script>
export default {
  computed: {
    isShow: ({ $store }) => $store.state.dialog.isLoading,
    message: ({ $store }) => $store.state.dialog.loadingMessage,
  },
};
</script>

<style scoped lang="scss">
.loading /deep/ {
  .progress-circular__primary {
    stroke: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// loading.vue?1c46ec2d